import { render } from "./Time.vue?vue&type=template&id=b13667c6&scoped=true&ts=true"
import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"

import "./Time.vue?vue&type=style&index=0&id=b13667c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13667c6"]])

export default __exports__